import { render, staticRenderFns } from "./CmpArrearage.vue?vue&type=template&id=049b637c&scoped=true&"
import script from "./CmpArrearage.vue?vue&type=script&lang=js&"
export * from "./CmpArrearage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049b637c",
  null
  
)

export default component.exports